import React from 'react';
import { useTranslation } from 'react-i18next';
import './index.css';

const BuyLicenses = () => {
    const { t } = useTranslation();

    return (
        <div className="d-flex align-items-center">
            <a title={t("textBuyLicenses")} className="buy-licenses" data-content={t("textBuyLicenses")} href={`/payment/add`} target="_blank" rel="noreferrer">
                <svg version="1.1" baseProfile="tiny"
                     x="0px" y="0px" viewBox="0 0 48 48"
                     xmlSpace="preserve">
                    <circle fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeMiterlimit="10" cx="24" cy="24" r="14"/>
                    <g>
                        <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeMiterlimit="10" x1="24" y1="15.3" x2="24" y2="32.8"/>
                    </g>
                    <g>
                        <line fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeMiterlimit="10" x1="32.8" y1="24" x2="15.3" y2="24"/>
                    </g>
                </svg>
            </a>
        </div>

    );
};

export default BuyLicenses;
